import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useNavigate,useLocation,useParams, Outlet } from 'react-router-dom';
import { PiTrash, PiUsersThree, PiUsersThreeLight } from "react-icons/pi";
import {QuestionDialog, ContentContainer, createDialog, ListItem} from 'coaz-ui';
import client from '../client';
import AddUserType from './AddUserType';


const UserTypes = () => {
    const {version,setVersion} = useContext(GlobalContext);
    const [userTypes,setUsersTypes] = useState([]);
    const [buttons,setButtons] = useState([]);
    const [loading,setLoading] = useState(true);
    const [itemButtons,setItemButtons] = useState(null);
    const {request,getCurrent,errorMessage} = client;
    const {userTypeId} = useParams();
    const path = useLocation().pathname;

    const navigate = useNavigate();

    const onAddUserType = (e) => {
        createDialog({
            title:"Add User Type",
            Component:AddUserType,
            version:version,
            setVersion:setVersion
        })
    }

    const onOpen = (item) => {
        if(!item || !item.id) return;
        navigate(`${path}/_usertype/${item.id}`)
    }

    const handleDeleteUserType = (item) => {
        if(!item) return;
        createDialog({
            title:'Delete User Type',
            submitText:"Yes",
            cancelText:"No",
            params:{
                submit:async (e) => {
                        try {
                            await request('DELETE',`user-types/${item.id}`)
                            return {
                                message: 'Successful',
                                success: true
                            };
                        } catch (error) {
                            return {
                                message: errorMessage(error)
                            };
                        }
                    },
                message:`Are you sure you want to delete ${item.text}? all users with this user type will be deleted!`
            },
            Component:QuestionDialog,
            version:version,
            setVersion:setVersion
        })
    }

    const getUserTypes = async () => {
        await request('GET','user-types')
        .then((response) => {
            if(response) {
                setUsersTypes(response);
            } else {
                setUsersTypes([]);
            }
        })
        .catch((error) => {
            setUsersTypes([]);
        });
    }

    const load = async () => {
        !loading && setLoading(true);
        const current = await getCurrent();

        if(!current) return;

        let createUserType = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:CREATE'});
        let deleteUserType = current.authorities.find((auth) => {return auth.authority === 'USERTYPE:DELETE'});

        if(createUserType) {
            setButtons([
                {
                    Icon:PiUsersThree,
                    name:'Add User Type',
                    handler:onAddUserType
                }
            ])
        }
        
        if(deleteUserType) {
            setItemButtons([
                {
                    name:'Delete',
                    Icon:PiTrash,
                    handler:handleDeleteUserType
                }
            ])
        }
        await getUserTypes();
        setLoading(false)
    }

    useEffect(() => {
        load();
    },[version])

    if(userTypeId) {
        return (<Outlet/>)
    } else {
        return (
            <ContentContainer buttons={buttons} Icon={PiUsersThreeLight} text='User Types' background={true} scrollable={true} loading={loading}>
                {userTypes && userTypes.length > 0 &&
                <div className='flex flex-col w-full h-auto space-y-2'>
                    {userTypes.map((userType,i) => 
                    <ListItem 
                        key={i} 
                        Icon={PiUsersThreeLight} 
                        item={{id:userType.ref.id,text:userType.name}} 
                        buttons={!userType.reserved?itemButtons:null}
                        handleOpen={onOpen}
                    />)}
                </div>
                }
            </ContentContainer>
        )
    }
  
}

export default UserTypes